// src/page.ts
var PageType = /* @__PURE__ */ ((PageType2) => {
  PageType2["CUSTOM"] = "custom";
  PageType2["TEMPLATE"] = "template";
  PageType2["CATEGORY"] = "category";
  PageType2["TAG"] = "tag";
  PageType2["STORY"] = "story";
  PageType2["STATIC"] = "static";
  return PageType2;
})(PageType || {});
var getPage = (client, provider) => async (id) => {
  return await client.get(`/${provider}/pages/${id}`).json();
};
var createPage = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/pages`, { json: data, ...options }).json();
};
var updatePage = (client, provider) => async (id, data, options) => {
  return await client.patch(`${provider}/pages/${id}`, { json: data, ...options }).json();
};
var deletePage = (client, provider) => async (id, options) => {
  await client.delete(`${provider}/pages/${id}`, options);
};
var getPages = (client, provider) => async (options) => {
  return await client.get(`${provider}/pages`, options).json();
};
var addPageComponent = (client, provider) => async (id, componentId, index, options) => {
  return await client.post(`${provider}/pages/${id}/components/${componentId}`, { json: { index }, ...options }).json();
};
var removePageComponent = (client, provider) => async (id, componentId, options) => {
  return await client.delete(`${provider}/pages/${id}/components/${componentId}`, options).json();
};
var getPageByCategory = (client, provider) => async (categoryId, options) => {
  return await client.get(`${provider}/pages/categories/${categoryId}`, options).json();
};
var getPageByTag = (client, provider) => async (tagId, options) => {
  return await client.get(`${provider}/pages/tags/${tagId}`, options).json();
};
var getPageByStory = (client, provider) => async (storyId, options) => {
  return await client.get(`${provider}/pages/stories/${storyId}`, options).json();
};
var getPageBySlug = (client, provider) => async (slug, options) => {
  return await client.get(`${provider}/pages/custom/${slug}`, options).json();
};
var createPageApi = (client, provider) => {
  return {
    getPage: getPage(client, provider),
    createPage: createPage(client, provider),
    updatePage: updatePage(client, provider),
    deletePage: deletePage(client, provider),
    getPages: getPages(client, provider),
    addPageComponent: addPageComponent(client, provider),
    removePageComponent: removePageComponent(client, provider),
    getPageByCategory: getPageByCategory(client, provider),
    getPageByTag: getPageByTag(client, provider),
    getPageByStory: getPageByStory(client, provider),
    getPageBySlug: getPageBySlug(client, provider)
  };
};

export {
  PageType,
  createPageApi
};
